import BaseService from './_base.service';

export const lensService = {
    page,
    search,
    edit,
    create,
    one,
    remove,
    comboSerie,
    removeLogic
};

function page(page,size, callback) {
    return BaseService.get("/lens/page/"+page+"/"+size, callback, true)
}
function comboSerie(idLens,callback) {
    return BaseService.get("/lens/serie/"+idLens+"/combo/", callback, true)
}
function search(page,size,filter, callback) {
    return BaseService.post("/lens/page/"+page+"/"+size,filter, callback, true)
}


function edit(id, bodyelement, callback) {
    let body = JSON.stringify(bodyelement)
    return BaseService.put("/lens/"+id, body, callback, true)
}

function create(bodyelement, callback) {
    //let body = JSON.stringify(bodyelement)
    return BaseService.post("/lens/", bodyelement, callback, true)
}

function one(id,callback) {
    return BaseService.get("/lens/one/"+id, callback);
}

function remove(id,callback) {
    return BaseService.delete("/lens/"+id, callback);
}

function removeLogic(id,callback) {
    return BaseService.delete("/lens/"+id+"/logic", callback);
}
